import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppContext } from './context/AppContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import LiveClassPage from './pages/LiveClassPage';
import RecordingsPage from './pages/RecordingsPage';

const PrivateRoute = ({ children }) => {
  const { user } = useContext(AppContext);
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const App = () => {
  return (
    <div className="app-root d-flex flex-column">
      <Navbar />
      <main className="page-content container py-3">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/live-class/:roomCode"
            element={
              <PrivateRoute>
                <LiveClassPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/recordings"
            element={
              <PrivateRoute>
                <RecordingsPage />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;
